import React, { useRef } from 'react'
import { Col } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUpload, faTimesCircle } from '@fortawesome/pro-solid-svg-icons'

import IFormFieldProps from 'interfaces/form-field-props'
import Button from 'design-system/button'
import { ButtonVariant, ButtonSizes } from 'design-system/button/src/Button'
import InputLabel from '../input-label/InputLabel'
import styles from './FileInput.module.scss'

const FileInput: React.FC<IFormFieldProps> = ({
  label,
  comment = '',
  name,
  value,
  onChange,
  disabled,
}) => {
  let inputRef: any = useRef()
  const handleSelectFile = (event: any) => {
    const [file] = event.target.files
    if (file) {
      onChange(file)
    }
  }

  const handleUploadClick = () => {
    const input = inputRef
    if (input) {
      input.value = ''
      input.click()
    }
  }

  return (
    <Col className="p-0 ">
      <div className={'d-flex pl-3 d-flex align-items-center'}>
        <div className={`d-flex flex-column ${styles.container}`}>
          <InputLabel
            label={label || ''}
            className={styles.regularDescription}
          />
          <p className={styles.comment}>{comment}</p>
        </div>

        <div className={`${styles.fileInputWrapper}`}>
          <input
            id={`contained-button-file-${name}`}
            accept="image/png, image/jpeg"
            ref={(ref) => (inputRef = ref)}
            name={name}
            className="file-input"
            type="file"
            onChange={handleSelectFile}
            disabled={disabled}
          />
          <Button
            variant={ButtonVariant.Secondary}
            size={ButtonSizes.Small}
            className={styles.inputButton}
            onClick={handleUploadClick}
            disabled={disabled}
          >
            <div className={'d-flex'}>
              <FontAwesomeIcon
                icon={faUpload}
                className={` ${!value || value.name === '' ? 'mr-xl-2' : ''}`}
              />
              {(!value || value.name === '') && (
                <div className={`${styles.fileIputText}`}> {label}</div>
              )}
            </div>
          </Button>
        </div>
        {value && value.name && (
          <>
            <div
              className={`${styles.fileNameContainer} px-3 text-left text-truncate`}
            >
              {value && value.name}
            </div>
            <a
              className={styles.deleteFileIcon}
              onClick={() => {
                onChange('')
              }}
            >
              <FontAwesomeIcon icon={faTimesCircle} />
            </a>
          </>
        )}
      </div>
    </Col>
  )
}

export default FileInput
